import StandardEvent from './StandardEvent';
export class GoogleStandardEvents {
    addPaymentInfo() {
        return new StandardEvent('add_paymennt_info');
    }
    addShippingInfo() {
        return new StandardEvent('add_shipping_info');
    }
    addToCart() {
        return new StandardEvent('add_to_cart');
    }
    addToWishList() {
        return new StandardEvent('add_to_wishlist');
    }
    beginCheckout() {
        return new StandardEvent('begin_checkout');
    }
    earnVirtualCurrency() {
        return new StandardEvent('earn_virtual_currency');
    }
    generateLead() {
        return new StandardEvent('generate_lead');
    }
    joinGroup() {
        return new StandardEvent('join_group');
    }
    levelEnd() {
        return new StandardEvent('level_end');
    }
    levelStart() {
        return new StandardEvent('level_start');
    }
    levelUp() {
        return new StandardEvent('level_up');
    }
    login() {
        return new StandardEvent('login');
    }
    postScore() {
        return new StandardEvent('post_score');
    }
    purchase() {
        return new StandardEvent('purchase');
    }
    refund() {
        return new StandardEvent('refund');
    }
    removeFromCart() {
        return new StandardEvent('remove_from_cart');
    }
    search() {
        return new StandardEvent('search');
    }
    selectContent() {
        return new StandardEvent('select_content');
    }
    selectItem() {
        return new StandardEvent('select_item');
    }
    selectPromotion() {
        return new StandardEvent('select_promotion');
    }
    share() {
        return new StandardEvent('share');
    }
    signUp() {
        return new StandardEvent('sign_up');
    }
    spendVirtualCurrency() {
        return new StandardEvent('spend_virtual_currency');
    }
    tutorialBegin() {
        return new StandardEvent('tutorial_begin');
    }
    tutorialComplete() {
        return new StandardEvent('tutorial_complete');
    }
    unlockAchievement() {
        return new StandardEvent('unlock_achievement');
    }
    viewCart() {
        return new StandardEvent('view_cart');
    }
    viewItem() {
        return new StandardEvent('view_item');
    }
    viewItemList() {
        return new StandardEvent('view_item_list');
    }
    viewPromotion() {
        return new StandardEvent('view_promotion');
    }
}
//# sourceMappingURL=StandardEvents.js.map